import { render, staticRenderFns } from "./AssignmentStatus.vue?vue&type=template&id=51047e70&scoped=true"
import script from "./AssignmentStatus.vue?vue&type=script&lang=js"
export * from "./AssignmentStatus.vue?vue&type=script&lang=js"
import style0 from "./AssignmentStatus.vue?vue&type=style&index=0&id=51047e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51047e70",
  null
  
)

export default component.exports